import { useTranslation } from "react-i18next";
import { useContractingCustomerTypeValue } from "./useContractingCustomerTypeValue";
import { CustomerType } from "features/customer/enums/customerType";

export const useContractingAddressName = (): string => {
  // translations
  const tLabels = useTranslation(
    "contracting\\enums\\contractingAddressType"
  ).t;

  // store
  const customerType =
    useContractingCustomerTypeValue<CustomerType>("customerType");

  // return
  return tLabels(customerType);
};
